import { BaseRouteService } from "./BaseRouteService";

export class RegisterService extends BaseRouteService {
    public async register(
        username: string,
        password: string,
        playerSessionId: string
    ): Promise<{ success: boolean; sessionId?: string; error?: string }> {
        try {
            const response: {
                message: string;
                sessionId: string;
            } = await this.postJsonApi<{
                message: string;
                sessionId: string;
            }>("game/register", {
                username,
                password,
                playerSessionId,
            });

            console.log("[RegisterService] Registratie response (200):", response);

            return {
                success: true,
                sessionId: response.sessionId,
            };
        }
        catch (err: unknown) {
            let errorMessage: string = "Onbekende fout";

            if (typeof err === "object" && err !== null) {
                const errorObj: {
                    response?: {
                        data?: {
                            error?: string;
                        };
                    };
                    message?: string;
                } = err as { response?: { data?: { error?: string } }; message?: string };

                errorMessage = errorObj.response?.data?.error || errorObj.message || errorMessage;
            }

            console.error("[RegisterService] Fout tijdens registratie:", errorMessage);

            return {
                success: false,
                error: errorMessage,
            };
        }
    }
}
